import React from 'react';
import { InappmessagesProps, fallbackImage } from '../inappmessages';
import { Picture } from '../../../elements/picture/picture';
import { BodyContent } from './bodyContent';

import styles from '../inappmessages.module.scss';
import classNames from 'classnames';

export function InappmessageFullGraphic({
  data,
  onClosePopup,
}: {
  data: InappmessagesProps;
  onClosePopup: Function;
}) {
  const { imageUrl, extras, buttons, openTarget, imageStyle } = data;
	const hideGradient = extras.hideGradient !== undefined && extras.hideGradient === 'true';

  return (
    <main className={classNames(styles.fullGraphic, (!hideGradient ? styles.fullGraphicGradient : ''))}>
      <Picture
        className={styles.fullImage}
        sizes={[{ url: imageUrl }]}
        lazyLoad={true}
        isAMP={false}
        fallback={fallbackImage}
      ></Picture>
      <div className={styles.contentWrapper}>
        <BodyContent
          title={extras.Title || ''}
          description={extras.Description || ''}
          category={extras.Category || ''}
          buttons={buttons}
          openTarget={openTarget}
          imageStyle={imageStyle}
          onClosePopup={onClosePopup}
          inAppMessage={data}
        />
      </div>
    </main>
  );
}
